import { FormSelect } from '@systemeio/ui'
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper'
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface'
import {
  AutomationRuleTriggersDataEnum,
  AutomationRuleTriggersEnum,
} from 'modules/automation-rules/triggers/enums/trigger-enum'
import { TriggerWebsiteEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface'
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface TriggerBlogItemProps extends EditTriggerItemInterface<TriggerWebsiteEditInterface> {}

export const TriggerWebsiteItem = ({
  triggers,
  trigger,
  idx,
  onDelete,
  setRules,
  errors,
  isStatic,
}: TriggerBlogItemProps) => {
  const { t } = useLocoTranslation()

  return (
    <EditTriggerWrapper trigger={trigger} onDelete={() => onDelete(idx)}>
      {({ renderTriggerLabel, data, onOpen }) => (
        <>
          <FormSelect
            disabled={isStatic}
            onOpen={() => onOpen(AutomationRuleTriggersDataEnum.website_form_subscribed)}
            label={renderTriggerLabel({
              label: t('dashboard.automation_rule.website_title'),
            })}
            placeholder={t('dashboard.automation_rule.choose_website')}
            value={trigger.website.id}
            staticData={getDataFromObj(trigger.website)}
            data={data.websiteData}
            onChange={data => {
              setRules(prev => {
                return {
                  ...prev,
                  triggers: triggers.map((el, i) => {
                    if (idx === i) {
                      return {
                        ...el,
                        website: { id: data, websitePage: { id: undefined, name: undefined } },
                      }
                    } else {
                      return el
                    }
                  }),
                }
              })
            }}
            error={errors.automationTriggers[trigger.id]?.websiteId?.join('')}
          />
          {trigger.website.id && (
            <FormSelect
              disabled={isStatic}
              onOpen={() => onOpen(AutomationRuleTriggersDataEnum.website_form_subscribed)}
              label={renderTriggerLabel({
                label: t('dashboard.automation_rule.website_page_title'),
              })}
              placeholder={t('dashboard.automation_rule.choose_website_page')}
              value={trigger.website.websitePage.pageContentId}
              staticData={getDataFromObj({
                id: trigger.website.websitePage.pageContentId,
                name: trigger.website.websitePage.name,
              })}
              data={data.websitePageData}
              onChange={data => {
                setRules(prev => {
                  return {
                    ...prev,
                    triggers: triggers.map((el, i) => {
                      if (idx !== i) {
                        return el
                      }

                      if (el.type === AutomationRuleTriggersEnum.website_form_subscribed) {
                        return {
                          ...el,
                          website: {
                            ...el.website,
                            websitePage: { pageContentId: data },
                          },
                        }
                      }

                      return el
                    }),
                  }
                })
              }}
              error={errors.automationTriggers[trigger.id]?.page?.join('')}
            />
          )}
        </>
      )}
    </EditTriggerWrapper>
  )
}
